/* eslint-disable prefer-destructuring,func-names,react/prop-types */

import React from 'react';
import { Icon, Layout } from 'antd';
import styledComponents from 'styled-components';
import UserProfile from '../../views/UserProfileView';
import { MEDIA_MD } from '../../views/styleConstants';
import VbLogo from './VbLogo';
import smallLogo from '../../../static/voicebase-sm.svg';

const StyledHeader = styledComponents(Layout.Header)`
      height: 58px; 
      line-height: 0; 
      background-color: #fff; 
      display: flex; 
      flex-direction: row; 
      align-items: center;
      padding: 0 18px;
      
      .voicebase-logo { 
        margin: 5px 20px 0 0;
        cursor: pointer;
        .sm-logo {
          display: none;
        }
        .lrg-logo {
          display: block;
          width: 140px;
        }
        @media screen and (max-width: ${MEDIA_MD}) {
          .lrg-logo {
            display: none;
          }
          .sm-logo {
            display: block;
            width: 31px;
          }
        }
      }
      
      .page-title {
        color: rgb(0, 121, 191);
        font-size: 25px;
        margin: -3px 0 0 -21px;
        opacity: 0.9;
        cursor: pointer;
      }
      
      .toggle-sidebar {
        margin-right: 20px;
        margin-left: 5px;
        color: #a5a5a5;
        &:hover { color: #0279c0; }
      }
      
      &.sub-header{
        height: 15px; 
        background: rgb(26, 43, 58);
        .ant-breadcrumb-separator {
          color: rgba(255, 255, 255, 0.65);
        }
        .ant-breadcrumb {
          color: rgba(255, 255, 255, 0.65);
          > span:last-child {
            color: rgba(255, 255, 255, 0.65);
          }
        }
      }
    `;

export default ({
  login, profile, logout, goHome, toggleSidebar,
}) =>
  (
    <div>
      <StyledHeader>
        <div onClick={toggleSidebar} className="toggle-sidebar">
          <Icon type="menu" />
        </div>
        <div className="voicebase-logo" onClick={goHome}>
          <span className="lrg-logo"><VbLogo /></span>
          <span className="sm-logo"><img src={smallLogo} /></span>
        </div>
        <div className="page-title" onClick={goHome}>Developer Portal</div>
        <UserProfile profile={profile} login={login} logout={logout} />
      </StyledHeader>
      <StyledHeader className="sub-header" />
    </div>
  );

